// src/frontend_react/src/pages/UserDashboard/JobOverviewTab.js
import React from 'react';
import { useOutletContext } from 'react-router-dom';
import ContributionChecklist from '../../components/userDashboard/ContributionChecklist'; 
import Card from '../../components/ui/Card/Card';
import Stack from '../../components/ui/Stack/Stack'; 

const JobOverviewTab = () => {
  const { job } = useOutletContext();

  if (!job) {
    return null; 
  }

  return (
    <Stack>
      <ContributionChecklist 
        job={job} 
        dataSourceStatuses={job.data_source_types_status || []} 
      />
    </Stack>
  );
};

export default JobOverviewTab;